module.exports = __webpack_public_path__ + "img/Täuschung.88556bca.jpg";